import { memo } from 'react';
import { ExamDatesForLocationDto } from '../common/types';
import { TableRow, TableCell } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { MemoTableCell } from './MemoTableCell';
import { compareMonthAndYearOnly } from '../common/utilities';

interface MemoTableRowProps {
  rowData: ExamDatesForLocationDto;
  rowIndex: number;
  isEditable: boolean;
  date: Date;
  onCellChange: (rowIndex: number, cellIndex: number, newValue: boolean) => void;
}

export const MemoTableRow: React.FC<MemoTableRowProps> = memo(
  ({ rowData, rowIndex, isEditable, date, onCellChange }) => {
    return (
      <S.TableRow isEditable={isEditable}>
        <S.TableCell>{rowData.location}</S.TableCell>
        {rowData.dates
          .filter((d) => compareMonthAndYearOnly(d.date, date))
          .map((cellData, cellIndex) => (
            <MemoTableCell
              key={`${rowData.locationId}-${cellIndex}`}
              cellData={cellData}
              rowIndex={rowIndex}
              cellIndex={cellIndex}
              isEditable={isEditable}
              onCellChange={onCellChange}
            />
          ))}
      </S.TableRow>
    );
  }
);

const S = {
  TableRow: styled(TableRow)<{ isEditable: boolean }>`
    background-color: ${(props) => (!props.isEditable ? '#efefef !important' : 'initial')}};
  `,
  TableCell: styled(TableCell)`
    padding: 10px;
    border-right: 1px solid rgba(34, 36, 38, 0.1);
  `,
};
